module.exports = __webpack_public_path__ + "static/media/user_image.8d17db1b.png";